export default {
  api_endpoint: process.env.API_ENDPOINT || "https://api.lab.storiusapp.com",
  host_endpoint: process.env.HOST_ENDPOINT || "https://player.storiusapp.com",
};
